<div style="border-left: 2px solid #fff; border-right: 2px solid #fff; padding: 0 15px 0 10px; margin-left: 8px; margin-right: 8px;">
  <a (click)="viewReminder()" style="cursor: pointer;"  matTooltip="Nombre de dossiers avec un nouveau commentaire">
    <mat-icon matBadge="{{nbDossiers}}" matBadgeColor="warn">notifications_none</mat-icon>
  </a>
</div>
